"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var I18n = require("i18n-js");
var classNames = require("classnames");
var refund_request_1 = require("./refund_request");
var form_fields_1 = require("./form_fields");
var NoteToOtherParty = function (props) {
    function otherParty() {
        if (props.userType === refund_request_1.IUserType.BUYER) {
            return refund_request_1.IUserType.SELLER;
        }
        return refund_request_1.IUserType.BUYER;
    }
    function isNoteRequired() {
        if (props.viewContext === form_fields_1.ViewContext.CONFIRM) {
            return false;
        }
        if (props.userType === refund_request_1.IUserType.BUYER) {
            return true;
        }
        return props.refundReason === refund_request_1.OTHER_REASON;
    }
    function noteClassNames() {
        return classNames({
            wide: true,
            required: isNoteRequired(),
        });
    }
    function refundNoteLabelHintText() {
        if (isNoteRequired()) {
            return I18n.t('discovery.dashboard.refundRequests.required');
        }
        return I18n.t('discovery.dashboard.refundRequests.optional');
    }
    function noteToOtherParty() {
        if (props.userType === refund_request_1.IUserType.BUYER) {
            return I18n.t('discovery.dashboard.refundRequests.noteToSeller');
        }
        return I18n.t('discovery.dashboard.refundRequests.noteToBuyer');
    }
    function renderReturnAddressHint() {
        if (props.userType === refund_request_1.IUserType.BUYER) {
            return false;
        }
        return (React.createElement("div", { className: "form-group__help-text" }, I18n.t('discovery.dashboard.refundRequests.returnAddressHint')));
    }
    function inputName() {
        if (props.viewContext === form_fields_1.ViewContext.CONFIRM) {
            return 'order_refund_request[final_note_to_buyer]';
        }
        return "order_refund_request[note_to_" + otherParty() + "]";
    }
    function inputId() {
        if (props.viewContext === form_fields_1.ViewContext.CONFIRM) {
            return 'order_refund_request_final_note_to_buyer';
        }
        return "order_refund_request_note_to_" + otherParty();
    }
    return (React.createElement("div", { className: "form-group" },
        React.createElement("div", { className: "form-group__header" },
            React.createElement("label", { className: "form-group__label-text", htmlFor: "order_refund_request_note_to_" + otherParty() }, noteToOtherParty()),
            React.createElement("div", { className: "form-group__tag" }, refundNoteLabelHintText())),
        React.createElement("div", { className: "form-group__fields" },
            React.createElement("textarea", { id: inputId(), name: inputName(), className: noteClassNames(), cols: 50, rows: 2, required: isNoteRequired(), value: props.note, onChange: props.onNoteChange }),
            renderReturnAddressHint())));
};
exports.default = NoteToOtherParty;
//# sourceMappingURL=note_to_other_party.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/refund_requests/note_to_other_party.js
// module id = Eytq
// module chunks = 20 21